import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";

import { Button } from "./ui/button";
import useFirebaseGlassData from "../hooks/useFirebaseGlassData";
import { getGlassDataDropdownOptionsFromInventory } from "../helpers/glassHelpers";

import { HookInput as Input, HookDropdown as Dropdown } from "../helpers/formHelpers";

const MaterialForm = ({ initialValues, onSubmit, glass_type }: { initialValues: any; onSubmit: any; glass_type: any }) => {
  const schema = yup.object().shape({});

  const { control, handleSubmit, formState } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });
  const { errors } = formState;
  const glass_data = useFirebaseGlassData(glass_type);
  const options = getGlassDataDropdownOptionsFromInventory(glass_data?.inventory);
  return (
    <div className="border rounded-lg p-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input control={control} errors={errors} name="description" label="Description" />
        <Dropdown
          control={control}
          errors={errors}
          name="glass_reference"
          label={`${glass_type} Glass Reference`}
          defaultValue={initialValues.glass_reference}
          search
          clearable
          options={options}
          placeholder={`Select a ${glass_type} item`}
        />
        <Button
          variant="outline"
          onClick={handleSubmit(onSubmit)}
          disabled={!formState.isDirty || formState.isSubmitting}
        >
          Update
        </Button>
      </form>
    </div>
  );
};

export default MaterialForm;
